<template>
  <div class="charts">
    <chart-box
      v-for="(k, i) in chartList"
      :key="k.id"
      :chartData="chartList[i]"
    ></chart-box>
  </div>
</template>
<script>
import chartBox from "./chartBox.vue";
export default {
  props: ["chartListData"],
  components: { chartBox },
  data() {
    return {
      chartList: [],
      isEdit: false,
    };
  },
  mounted() {
    this.chartList = this.chartListData;
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.charts {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .chartBox {
    width: 100%;
    height: 32%;
  }
}
</style>